import { useMutation } from '@tanstack/react-query';
import { ActorsAPI } from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

const actorsAPI = new ActorsAPI(axios);

// DELETE User Actor
export const useDeleteActorMutation = () =>
    useMutation({
        mutationFn: async ({ actorId }: { actorId: string }) =>
            actorsAPI.deleteUserActor(actorId)
    });
